import React from 'react'
import { Navigate } from 'react-router-dom';

const ProtectedRoutes = ({element}) => {
    let isAuthenticated=localStorage.getItem("token");
  return (
   <>
    {isAuthenticated?element:<Navigate to={"/login"}/>}
   </>
  )
}

export default ProtectedRoutes
